import type { ApiClient } from '@travel/api-client';

import { MONTEROSA_API_TIMEOUT } from 'store/utils';

import type { PlanDetails, RequestBody } from 'PlanDetails-Types';
export const fetchPlanDetails = (
  http: ApiClient,
  query: RequestBody,
  ipAddress?: string,
): Promise<PlanDetails> => {
  const headers = ipAddress ? { 'trv-client-ip': ipAddress } : undefined;
  return http.post(`/monterosa-api-dp/dp/jrdp/plan-details`, {
    values: query,
    timeout: MONTEROSA_API_TIMEOUT,
    headers,
  });
};
